export function IframeChat() {
  return (
    <div className="flex flex-col h-full w-full overflow-hidden rounded-md border border-border/40">
      <iframe
        src="https://fayezzouari-beagleboard-chat.hf.space"
        title="BeagleBoard Chatbot"
        className="w-full h-full border-none"
        style={{ minHeight: "calc(100vh - 120px)" }}
      />
    </div>
  )
}

